import React, {Fragment, useEffect, useState} from "react";
import './AppMeasurements.scss'
import jsonview from '@pgrabovets/json-view';

const AppMeasurements = () => {

    const [data, setData] = useState(null)
    const [errorIdToken, setErrorIdToken] = useState(false)
    const [responseStatus, setResponseStatus] = useState(null)
    const [jsTest, setJsTest] = useState(false)

    useEffect(() => {
        getMeasurements()
    }, [])

    useEffect(() => {
        testJs()
    }, [])


    const testJs = () => {
        setJsTest(true)
        setTimeout(() => setJsTest(false), 2000)
    }

    //ID 1095
    ///measurements?sensorId=1095

    // const newHeaders = () => {
    //
    //     var myRequest = new Request(document.location);
    //     let headers = new Headers({'cookie':'cokie'})
    //
    //     fetch(myRequest).then(function(response) {
    //         // for each response header, log an array with header name as key
    //         console.log(...response.headers);
    //         // response.blob().then(function(myBlob) {
    //         //     var objectURL = URL.createObjectURL(myBlob);
    //         //     myImage.src = objectURL;
    //         // });
    //     });
    // }

    const getHeaders = () => {
        // fetch(document.location).then(response=>{
        //     console.log(response)
        //     console.log(response.headers)
        // })
        // console.log(window.__INITIAL_HEADERS__)
        // let req = new XMLHttpRequest();
        // req.open('GET', document.location, false);
        // req.setRequestHeader("X-Foo", "Bar");
        // req.send(null);
        // let headers = req.getAllResponseHeaders().toLowerCase();
        // headers = headers.split(/\n|\r|\r\n/g).reduce(function(a, b) {
        //     if (b.length) {
        //         var [ key, value ] = b.split(': ');
        //         a[key] = value;
        //     }
        //     return a;
        // }, {});
        // console.log(req)
        //
        // // const div = document.querySelector('.AppMeasurements')
        // setData(headers)
        // console.log(JSON.stringify(headers));

    }

    const getMeasurements = () => {
        const queryString = window.location.search;

        const urlParams = new URLSearchParams(queryString);
        const sensorId = urlParams.get('sensorId')
        const key = urlParams.get('key')
        console.log(key)


        if(sensorId && key) {
            // fetch(`${process.env.REACT_APP_API_URL}/sensor_details?sensorId=${id}`, {
            fetch(`${process.env.REACT_APP_API_URL}/measurements?sensorId=${sensorId}`, {
                method: "GET",
                headers: {
                    // 'Content-Type': 'application/json; charset=UTF-8',
                    'Authorization': key,
                    // 'Access-Control-Expose-Headers': 'authorization'

                    // 'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
                }
            })
                .then(res => {
                    setResponseStatus(res.status)
                    if (res.status === 200) {
                       return res.json()
                    }
                })
                .then((data) => {
                    setData(data)
                    console.log(data)
                    const tree = jsonview.create(data.sensors);
                    jsonview.render(tree, document.querySelector('.AppMeasurements'));
                    jsonview.expand(tree);
                })
                // .then(res => {
                //     setData(res.sensors)
                // })
                .catch(err => {
                    console.log('ERROR', err);
                })
        } else {
            setErrorIdToken(true)
        }
    }



    const displayParams = () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const sensorId = urlParams.get('sensorId')
        const key = urlParams.get('key')

        return (
            <Fragment>
                <div><b>SENSOR ID:</b>&nbsp;{sensorId}</div>
                <div><b>KEY:</b>&nbsp;{key}</div>
            </Fragment>
        )
    }

    if(data) {
        return (
            <div className="AppMeasurements">
                {jsTest && (<div>JAVASCRIPT TIMEOUT TEST</div>)}
                {displayParams()}
                {responseStatus && (
                    <Fragment>
                        <div style={{'fontWeight': '600'}}>
                            RESPONSE status: {responseStatus}
                        </div>
                        <div>
                            SENSOR ID (from json): {data.sensors[0].id}
                        </div>
                    </Fragment>
                )}
            </div>
        )
    }

    return (
        <div className='AppMeasurements'>
            {jsTest && (<div>JAVASCRIPT TIMEOUT TEST</div>)}
            <div>
                {errorIdToken && (
                    <div>MISSING TOKEN OR ID</div>
                )}
                {responseStatus && (
                    <div style={{'fontWeight': '600'}}>
                        RESPONSE status: {responseStatus}
                    </div>
                )}
                {/*{displayParams()}*/}
            </div>
        </div>
    )

}

export default AppMeasurements
